import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: 100%;
  padding: 20px;
`;

export const BoxTitle = styled.div`
  width: 100%;
  max-width: 900px;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const BoxSearch = styled.div`
  width: 100%;
  max-width: 900px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const BoxFooter = styled.div`
  width: 100%;
  max-width: 900px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h1`
  color: #107faa;
  font-size: 16px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fffafa;
  max-width: 900px;

  @media (max-width: 425px) {
    display: block;
    width: 100%;
  }
`;

export const TableHead = styled.thead`
  @media (max-width: 425px) {
    display: none;
  }
`;

export const TableBody = styled.tbody`
  @media (max-width: 425px) {
    display: block;
    width: 100%;
  }
`;

export const TableRow = styled.tr`
  border: 1px solid #ccc;
  padding: 15px 15px;
  @media (max-width: 425px) {
    display: block;
    margin-bottom: 15px;
  }
`;

export const TableDataCells = styled.td`
  border: 1px solid #ccc;
  padding: 12px 15px;
  text-align: center;
  color: ${(props) => props.theme.text.darkGray};

  @media (max-width: 425px) {
    display: block;
    text-align: right;
    padding-left: 50%;
    position: relative;

    ::before {
      content: attr(data-label);
      position: absolute;
      left: 0;
      width: 50%;
      padding-left: 15px;
      font-size: 15px;
      font-weight: bold;
      text-align: left;
    }
  }
`;

export const HeadCells = styled.th`
  background: ${(props) => props.theme.background.blue};
  color: #fff;
  border: 1px solid #ccc;
  padding: 15px 15px;
`;
